/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PercentOutlinedIcon from "@mui/icons-material/PercentOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import StarRateRoundedIcon from "@mui/icons-material/StarRateRounded";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";
import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";
import BrushOutlinedIcon from "@mui/icons-material/BrushOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import NewReleasesOutlinedIcon from "@mui/icons-material/NewReleasesOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import FilterListIcon from "@mui/icons-material/FilterList";
import DownloadIcon from "@mui/icons-material/Download";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tab,
  Button,
  TextField,
} from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";
import EditCategoryCommission from "../../Modals/editCategoryCommission";
import AddVendorCommission from "../../Modals/addvendorcommission";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Commissions = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [rateFilter, setRateFilter] = useState("High Rate");
  const [saleRateFilter, setSaleRateFilter] = useState("Low Sale Rate");
  const [statusFilter, setStatusFilter] = useState("Emerging");
  // Vendor Tab Filters
  const [vendorSort, setVendorSort] = useState("High Vendor");
  const [planFilter, setPlanFilter] = useState("All Plans");
  const [vendorGlobalStatus, setVendorGlobalStatus] = useState("Active");

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const subscriptionData = [
    {
      id: "SUB001",
      type: "Basic Access",
      avgRate: 10.0,
      vendors: 58,
      status: "Active",
      statusClass: "success",
      statusIcon: <CheckCircleOutlineIcon style={{ fontSize: 16 }} />,
    },
    {
      id: "SUB002",
      type: "Pro Membership",
      avgRate: 7.0,
      vendors: 43,
      status: "Active",
      statusClass: "success",
      statusIcon: <CheckCircleOutlineIcon style={{ fontSize: 16 }} />,
    },
    {
      id: "SUB003",
      type: "Enterprise Plan",
      avgRate: 4.5,
      vendors: 15,
      status: "At Risk",
      statusClass: "danger",
      statusIcon: <WarningAmberRoundedIcon style={{ fontSize: 16 }} />,
    },
    {
      id: "SUB004",
      type: "Starter Plan",
      avgRate: 10.0,
      vendors: 40,
      status: "Paused",
      statusClass: "warning",
      statusIcon: <HourglassEmptyOutlinedIcon style={{ fontSize: 16 }} />,
    },
  ];
  const commissioncategorydata = [
    {
      id: "CAT001",
      name: "Home Services",
      rate: 8.0,
      icon: <HandymanOutlinedIcon className="c_primary" />,
      status: "Optimized",
      statusClass: "success",
      statusIcon: <VerifiedUserOutlinedIcon />,
      trend: "Rising",
      trendIcon: <TrendingUpRoundedIcon className="c_success" />,
    },
    {
      id: "CAT002",
      name: "Fashion Category",
      rate: 15.0,
      icon: <StarRateRoundedIcon className="c_warning" />,
      status: "High Rate",
      statusClass: "warning",
      statusIcon: <StarRateRoundedIcon />,
      trend: "Rising",
      trendIcon: <TrendingUpRoundedIcon className="c_success" />,
    },
    {
      id: "CAT003",
      name: "Handmade & Artisan",
      rate: 10.0,
      icon: <BrushOutlinedIcon className="c_success" />,
      status: "Emerging",
      statusClass: "success",
      statusIcon: <NewReleasesOutlinedIcon />,
      trend: "Rising",
      trendIcon: <TrendingUpRoundedIcon className="c_success" />,
    },
    {
      id: "CAT004",
      name: "New Vendor Rate",
      rate: 5.0,
      icon: <StorefrontOutlinedIcon className="c_info" />,
      status: "Reserved",
      statusClass: "highlight",
      statusIcon: <LockOutlinedIcon />,
      trend: "Reserved",
      trendIcon: <LockOutlinedIcon className="c_text" />,
    },
  ];

  const vendorCommissionData = [
    {
      id: "V001",
      name: "ABC Electronics",
      rating: 3,
      subscription: "Premium Plan",
      rate: 8.0,
      exempt: true,
      status: "Active",
      statusBadge: null,
    },
    {
      id: "V002",
      name: "Fashion Hub",
      rating: 4,
      subscription: "Free Plan",
      rate: 4.0,
      exempt: true,
      status: "Active",
      statusBadge: null,
    },
    {
      id: "V003",
      name: "Handmade Store",
      rating: 4,
      subscription: "Pro Seller",
      rate: 10.0,
      exempt: false,
      status: "At Risk",
      statusBadge: (
        <span
          className="badge1 danger"
          style={{ display: "flex", alignItems: "center", gap: "5px" }}
        >
          <WarningAmberRoundedIcon style={{ fontSize: 14 }} /> At Risk{" "}
          <ArrowDropDownIcon style={{ fontSize: 14 }} />
        </span>
      ),
    },
    {
      id: "V004",
      name: "Premium Seller",
      rating: 0,
      subscription: "Enterprise",
      rate: 12.0,
      exempt: true,
      status: "Paused",
      statusBadge: (
        <span
          className="badge1"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            background: "#f3f4f6",
            color: "#666",
          }}
        >
          <HourglassEmptyOutlinedIcon style={{ fontSize: 14 }} /> Paused
        </span>
      ),
    },
  ];
  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };
  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };
  return (
    <>
      <div className="main_title">
        <h1> Commissions</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Commissions
        </p>
      </div>
      <div className="stats_boxes gap_m">
        {/* TOTAL STRUCTURES */}
        <a className="cards">
          <div className="data_top">
            <h2>
              8<p>Total Structures</p>
            </h2>
            <figure className="blue">
              <AccountTreeOutlinedIcon fontSize="large" />
            </figure>
          </div>

          <div className="ai_insight info">
            <span>Configured</span>
            <small>across platform</small>
          </div>
        </a>

        {/* ACTIVE STRUCTURES */}
        <a className="cards">
          <div className="data_top">
            <h2>
              8<p>Active Structures</p>
            </h2>
            <figure className="sucess">
              <CheckCircleOutlineIcon fontSize="large" />
            </figure>
          </div>

          <div className="ai_insight positive">
            <span>100%</span>
            <small>activation rate</small>
          </div>
        </a>

        {/* AVG COMMISSION RATE */}
        <a className="cards">
          <div className="data_top">
            <h2>
              9.4%
              <p>Avg Commission Rate</p>
            </h2>
            <figure className="warning">
              <PercentOutlinedIcon fontSize="large" />
            </figure>
          </div>

          <div className="ai_insight info">
            <span>Optimized</span>
            <small>across categories</small>
          </div>
        </a>

        {/* VENDORS USING */}
        <a className="cards">
          <div className="data_top">
            <h2>
              156
              <p>Vendors Using</p>
            </h2>
            <figure className="active_order">
              <GroupsOutlinedIcon fontSize="large" />
            </figure>
          </div>

          <div className="ai_insight positive">
            <span>▲ Growing</span>
            <small>adoption rate</small>
          </div>
        </a>
      </div>

      <Box className="custom_tabs mt_20">
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          className="custom_tabs_links"
        >
          <Tab label="Commission by Subscription" {...a11yProps(0)} />
          <Tab label="Commission by Vendor" {...a11yProps(1)} />
          <Tab label="Commission by Service Category" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTabs} index={0}>
        <div className="table_flex">
          <div className="lt">
            <div className="cards">
              {/* Filter Section */}
              <div
                className="table_header"
                style={{ flexWrap: "wrap", gap: "10px" }}
              >
                <div className="left_s" style={{ flex: 1, gap: "10px" }}>
                  <Box className="search_box" style={{ minWidth: "200px" }}>
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search subscription..."
                    />
                  </Box>
                  <div
                    className="form"
                    style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
                  >
                    <div className="control_group">
                      <select style={{ minWidth: "130px" }}>
                        <option>Active (8)</option>
                        <option>Inactive (2)</option>
                      </select>
                    </div>
                    <div className="control_group">
                      <select style={{ minWidth: "130px" }}>
                        <option>All Plans</option>
                        <option>Premium</option>
                        <option>Free</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {/* Chip Filters */}
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  padding: "0 20px 20px 20px",
                  flexWrap: "wrap",
                }}
              >
                <span
                  className="badge1 warning"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    cursor: "pointer",
                  }}
                >
                  <StarRateRoundedIcon style={{ fontSize: 16 }} /> Low
                  Performing
                </span>
                <span
                  className="badge1"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    cursor: "pointer",
                    background: "#fff7ed",
                    color: "#9a3412",
                    border: "1px solid #ffedd5",
                  }}
                >
                  <NewReleasesOutlinedIcon style={{ fontSize: 16 }} /> High
                  Performing
                </span>
              
              </div>

              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sr. No</TableCell>
                      <TableCell>Subscription Type</TableCell>
                      <TableCell>Avg Comm. Rate</TableCell>
                      <TableCell>Vendors</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {subscriptionData.map((item, index) => (
                      <TableRow key={item.id} hover>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>
                          <b>{item.type}</b>
                        </TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>
                          {item.avgRate}%
                        </TableCell>
                        <TableCell>{item.vendors}</TableCell>
                        <TableCell>
                          <span
                            className={`badge1 ${item.statusClass}`}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            {item.statusIcon}
                            {item.status}
                          </span>
                        </TableCell>
                        <TableCell>
                          <div className="table_actions v2">
                            <IconButton onClick={() => navigate("view")}>
                              <img src="/static/images/edit2_icon.svg" />
                            </IconButton>
                            <IconButton>
                              <img src="/static/images/trash2_icon.svg" />
                            </IconButton>
                            <IconButton>
                              <CancelOutlinedIcon fontSize="small" />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            {/* Stats Section Below Table */}
            <div
              className="cards mt_20"
              style={{
                padding: "20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div className="stat_item">
                <h2
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#374151",
                    marginBottom: "5px",
                  }}
                >
                  9.4%{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#666",
                      fontWeight: "normal",
                    }}
                  >
                    Current Commission Rate &gt;
                  </span>
                </h2>
                <p style={{ color: "#666", fontSize: "12px" }}>
                  <span style={{ fontWeight: "bold" }}>&#x26a0; 26</span> At
                  Risk &nbsp;&nbsp;{" "}
                  <span style={{ fontWeight: "bold" }}>&#9729; 23</span> Plans
                </p>
              </div>
              <div className="stat_item">
                <h2
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#374151",
                    marginBottom: "5px",
                  }}
                >
                  1.3%{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#666",
                      fontWeight: "normal",
                    }}
                  >
                    Low Performing Vendors
                  </span>
                </h2>
                <p style={{ color: "#666", fontSize: "12px" }}>
                  <span style={{ fontWeight: "bold" }}>&#128101; 28</span>{" "}
                  Active Trials
                </p>
              </div>
              <div className="stat_item">
                <h2
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#059669",
                    marginBottom: "5px",
                  }}
                >
                  2.8%{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#666",
                      fontWeight: "normal",
                    }}
                  >
                    Plan Migration Rate
                  </span>
                </h2>
                <p style={{ color: "#666", fontSize: "12px" }}>
                  <span style={{ fontWeight: "bold", color: "#059669" }}>
                    &uarr; Increased 1.2x
                  </span>{" "}
                  vs last 30 days
                </p>
              </div>
            </div>
          </div>
          <div className="rt">
            <div className="ai_panel">
              <h4>AI Insights</h4>

              <div
                className="ai_alert warning"
                style={{ display: "block", borderLeft: "4px solid #d97706" }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      fontWeight: "bold",
                      color: "#374151",
                    }}
                  >
                    <TrendingUpRoundedIcon style={{ color: "#d97706" }} />{" "}
                    Subscription Churn Risk
                  </div>
                </div>
                <p
                  style={{
                    fontSize: "12px",
                    marginBottom: "15px",
                    color: "#666",
                  }}
                >
                  Enterprise Plan shows signs of churning vendors (3 this
                  month).
                </p>
                <Button
                  fullWidth
                  variant="contained"
                  style={{
                    backgroundColor: "#fff7ed",
                    color: "#9a3412",
                    textTransform: "none",
                    boxShadow: "none",
                    border: "1px solid #ffedd5",
                  }}
                >
                  View Risk Details
                </Button>
              </div>

              <div
                className="ai_alert success"
                style={{
                  display: "block",
                  backgroundColor: "#f0fdf4",
                  border: "1px solid #dcfce7",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      fontWeight: "bold",
                      color: "#166534",
                    }}
                  >
                    <CheckCircleOutlineIcon style={{ fontSize: 18 }} /> High
                    Growth Plan
                  </div>
                </div>
                <p
                  style={{
                    fontSize: "12px",
                    marginBottom: "10px",
                    color: "#14532d",
                  }}
                >
                  Basic Access plan adoption up by 15%.
                </p>
              </div>
            </div>
          </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs} index={1}>
        <div className="table_flex">
          <div className="lt">
            <div className="cards">
              {/* Filter Section */}
              <div
                className="table_header"
                style={{ flexWrap: "wrap", gap: "10px" }}
              >
                <div className="left_s" style={{ flex: 1, gap: "10px" }}>
                  <Box className="search_box" style={{ minWidth: "200px" }}>
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search vendors..."
                    />
                  </Box>
                  <div
                    className="form"
                    style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
                  >
                    <div className="control_group">
                      <select
                        value={planFilter}
                        onChange={(e) => setPlanFilter(e.target.value)}
                        style={{ minWidth: "130px" }}
                      >
                        <option value="All Subscriptions">All Subscriptions</option>
                        <option value="Premium">Premium</option>
                        <option value="Free">Free</option>
                      </select>
                    </div>
                    <div className="control_group">
                      <select
                        value={vendorGlobalStatus}
                        onChange={(e) => setVendorGlobalStatus(e.target.value)}
                        style={{ minWidth: "130px" }}
                      >
                        <option value="All Status">All Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                    </div>
                    <div className="control_group">
                      <select
                        value={vendorSort}
                        onChange={(e) => setVendorSort(e.target.value)}
                        style={{ minWidth: "130px" }}
                      >
                        <option value="Commission Rate">Commission Rate</option>
                        <option value="High Vendor">High Vendor</option>
                        <option value="Low Vendor">Low Vendor</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="right_s" style={{ gap: "10px" }}>
                  <Button
                    className="btn btn_grey sm"
                    variant="outlined"
                    startIcon={<DownloadIcon />}
                  >
                    Bulk Export CSV{" "}
                  </Button>
                </div>
              </div>

              {/* Chip Filters */}
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  padding: "0 20px 20px 20px",
                  flexWrap: "wrap",
                }}
              >
                <span
                  className="badge1"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    cursor: "pointer",
                    background: "#ecfdf5",
                    color: "#047857",
                    border: "1px solid #d1fae5",
                  }}
                >
                  <StorefrontOutlinedIcon style={{ fontSize: 16 }} /> tax exempt vendors
                </span>
              </div>
     

              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sr. No.</TableCell>
                      <TableCell>Vendor Name</TableCell>
                      <TableCell>Subscription</TableCell>
                      <TableCell>Rate</TableCell>
                      <TableCell>Exempt From Tax</TableCell>
                      <TableCell> Actions</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {vendorCommissionData.map((item, index) => (
                      <TableRow key={item.id} hover>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <img
                              src="/static/images/placeholder.png"
                              alt=""
                              style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                            />
                            <div>
                              <div style={{ fontWeight: "bold" }}>
                                {item.name}
                              </div>
                              {item.rating > 0 && (
                                <div
                                  style={{
                                    display: "flex",
                                    fontSize: "12px",
                                    color: "#f59e0b",
                                  }}
                                >
                                  {"★".repeat(item.rating)}
                                  {"☆".repeat(4 - item.rating)}
                                </div>
                              )}
                            </div>
                          </div>
                        </TableCell>
                        <TableCell style={{ color: "#666" }}>
                          {item.subscription}
                        </TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>
                          {item.rate}%
                        </TableCell>
                        <TableCell>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                          >
                            <SwitchToggle />
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="table_actions v2">
                            <IconButton onClick={() => setOpen(true)}>
                              <img src="/static/images/edit2_icon.svg" />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            {/* Stats Section Below Table */}
            <div
              className="cards mt_20"
              style={{
                padding: "20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div className="stat_item">
                <h2
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#059669",
                    marginBottom: "5px",
                  }}
                >
                  9.4%{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#666",
                      fontWeight: "normal",
                    }}
                  >
                    Current Commission Rate
                  </span>
                </h2>
                <p style={{ color: "#666", fontSize: "12px" }}>
                  <span style={{ fontWeight: "bold" }}>&#x2696; 26</span> At
                  Risk &nbsp;&nbsp;{" "}
                  <span style={{ fontWeight: "bold" }}>&#128196; 23</span> Plans
                </p>
              </div>
              <div className="stat_item">
                <h2
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#374151",
                    marginBottom: "5px",
                  }}
                >
                  1.3%{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#666",
                      fontWeight: "normal",
                    }}
                  >
                    Vendors in Routine Churn
                  </span>
                </h2>
                <p style={{ color: "#666", fontSize: "12px" }}>
                  <span style={{ fontWeight: "bold" }}>&#128196; 23</span> Plans
                </p>
              </div>
              <div className="stat_item">
                <h2
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#d97706",
                    marginBottom: "5px",
                  }}
                >
                  2.8%{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#666",
                      fontWeight: "normal",
                    }}
                  >
                    At-Risk Vendors
                  </span>
                </h2>
                <p style={{ color: "#666", fontSize: "12px" }}>
                  <span style={{ fontWeight: "bold" }}>&#x26a0; 2</span> At Risk
                </p>
              </div>
            </div>
          </div>

          <div className="rt">
            <div className="ai_panel">
              <h4>AI Recommendation</h4>

              {/* Card 1 */}
              <div
                className="ai_alert warning"
                style={{ display: "block", borderLeft: "4px solid #d97706" }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      fontWeight: "bold",
                      color: "#374151",
                    }}
                  >
                    <TrendingUpRoundedIcon style={{ color: "#d97706" }} />{" "}
                    Routine churn events
                  </div>
                </div>
                <p
                  style={{
                    fontSize: "12px",
                    marginBottom: "15px",
                    color: "#666",
                  }}
                >
                  2 Vendors (lists over time)
                </p>
                <Button
                  fullWidth
                  variant="contained"
                  style={{
                    backgroundColor: "#fff7ed",
                    color: "#9a3412",
                    textTransform: "none",
                    boxShadow: "none",
                    border: "1px solid #ffedd5",
                  }}
                >
                  Investigate Store
                </Button>
              </div>

              {/* Card 2 */}
              <div
                className="ai_alert success"
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <VerifiedUserOutlinedIcon style={{ fontSize: 20 }} />
                <span>No risks detected</span>
              </div>
            </div>
          </div>
        </div>
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs} index={2}>
        <div className="table_flex">
          <div className="lt">
            <div className="cards">
              {/* Filters Header */}
              <div
                className="table_header"
                style={{ flexWrap: "wrap", gap: "10px" }}
              >
                <div className="left_s" style={{ flex: 1, gap: "10px" }}>
                  <Box className="search_box" style={{ minWidth: "200px" }}>
                    <SearchBar
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setSearchTerm}
                      placeholder="Search categories..."
                    />
                  </Box>
                  <div
                    className="form"
                    style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
                  >
                    <div className="control_group">
                      <select
                        value={rateFilter}
                        onChange={(e) => setRateFilter(e.target.value)}
                        style={{ minWidth: "130px" }}
                      >
                        <option value="All Rates">All Rates</option>
                        <option value="High Rate">High Rate</option>
                        <option value="Medium Rate">Medium Rate</option>
                        <option value="Low Rate">Low Rate</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="right_s" style={{ gap: "10px" }}>
                  <Button
                    className="btn btn_grey sm"
                    variant="outlined"
                    startIcon={<DownloadIcon />}
                  >
                    Bulk Export CSV{" "}
                  </Button>
                  <Button
                    className="btn btn_primary sm"
                    onClick={() => setOpen(true)}
                  >
                    <AddIcon />
                    Add Commission
                  </Button>
                </div>
              </div>

              {/* Main Table */}
              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sr. No.</TableCell>
                      <TableCell>Category</TableCell>
                      <TableCell>Rate</TableCell>
                      <TableCell>Status</TableCell>
                    
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {commissioncategorydata.map((item, index) => (
                      <TableRow key={item.id} hover>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {item.icon}
                            <b>{item.name}</b>
                          </div>
                        </TableCell>
                        <TableCell>{item.rate}%</TableCell>
                        <TableCell>
                          <span
                            className={`badge1 ${item.statusClass}`}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            {item.statusIcon &&
                              React.cloneElement(
                                item.statusIcon as React.ReactElement,
                                { sx: { fontSize: 16 } },
                              )}
                            {item.status}
                          </span>
                        </TableCell>
                     
                        <TableCell>
                          <div className="table_actions v2">
                            <IconButton onClick={() => setOpen(true)}>
                              <img
                                src="/static/images/edit2_icon.svg"
                                alt="edit"
                              />
                            </IconButton>
                            <IconButton>
                              <img
                                src="/static/images/trash2_icon.svg"
                                alt="delete"
                              />
                            </IconButton>
                            <IconButton>
                              <CancelOutlinedIcon fontSize="small" />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            {/* Stats Section Below Table */}
            <div
              className="cards mt_20"
              style={{
                padding: "20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div className="stat_item">
                <h2
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#059669",
                    marginBottom: "5px",
                  }}
                >
                  9.4%{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#666",
                      fontWeight: "normal",
                    }}
                  >
                    Current Commission Rate &gt;
                  </span>
                </h2>
                <p style={{ color: "#666", fontSize: "12px" }}>
                  <span style={{ fontWeight: "bold" }}>&#x21ba; 26</span> High
                  Rate &nbsp;&nbsp;{" "}
                  <span style={{ fontWeight: "bold" }}>&#x2696; 12</span>{" "}
                  Reserved
                </p>
              </div>
              <div className="stat_item">
                <h2
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#65a30d",
                    marginBottom: "5px",
                  }}
                >
                  8.3%{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#666",
                      fontWeight: "normal",
                    }}
                  >
                    Reserved for New Vendors
                  </span>
                </h2>
                <p style={{ color: "#666", fontSize: "12px" }}>
                  <span style={{ fontWeight: "bold" }}>&#x1F465; 12</span>{" "}
                  Reserved
                </p>
              </div>
              <div className="stat_item">
                <h2
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#d97706",
                    marginBottom: "5px",
                  }}
                >
                  2.1%{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#666",
                      fontWeight: "normal",
                    }}
                  >
                    Standard Sale Rate
                  </span>
                </h2>
                <p style={{ color: "#666", fontSize: "12px" }}>
                  <span style={{ fontWeight: "bold" }}>&#x1F465; 21</span>{" "}
                  Emerging Reserved
                </p>
              </div>
            </div>
          </div>

          <div className="rt">
            <div className="ai_panel">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "15px",
                }}
              >
                <h4>AI Recommendations</h4>
                <div style={{ display: "flex", gap: "5px" }}>
                  <IconButton size="small">
                    <Box
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        border: "1px solid #ccc",
                      }}
                    />
                  </IconButton>
                  <IconButton size="small">
                    <MoreHorizIcon fontSize="small" />
                  </IconButton>
                </div>
              </div>

              {/* Card 1 */}
              <div className="ai_alert warning" style={{ display: "block" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    <TrendingUpRoundedIcon /> High Rate for Fashion
                  </div>
                  <MoreHorizIcon fontSize="small" style={{ color: "#ccc" }} />
                </div>
                <p style={{ fontSize: "12px", marginBottom: "10px" }}>
                  Review the 15% rate (too high), consider lowering to around
                  7.5%.
                </p>
                <p
                  style={{
                    fontSize: "11px",
                    color: "#666",
                    marginBottom: "10px",
                  }}
                >
                  &gt; AED 380,000 / mo added profit
                </p>
                <Button
                  size="small"
                  variant="contained"
                  style={{
                    backgroundColor: "#e5e7eb",
                    color: "#374151",
                    textTransform: "none",
                    boxShadow: "none",
                  }}
                >
                  Review Category
                </Button>
              </div>

              {/* Card 2 */}
              <div
                className="ai_alert success"
                style={{
                  display: "block",
                  backgroundColor: "#f0fdf4",
                  border: "1px solid #dcfce7",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      fontWeight: "bold",
                      color: "#166534",
                    }}
                  >
                    <NewReleasesOutlinedIcon /> Promising Emerging Category
                  </div>
                  <MoreHorizIcon fontSize="small" style={{ color: "#ccc" }} />
                </div>
                <p
                  style={{
                    fontSize: "12px",
                    marginBottom: "10px",
                    color: "#14532d",
                  }}
                >
                  Handmade & Artisan category (10%) shows rising sales rate.
                </p>
                <p
                  style={{
                    fontSize: "11px",
                    color: "#166534",
                    marginBottom: "10px",
                  }}
                >
                  &gt; Adjust rate: 10% &gt; 11%
                </p>
                <Button
                  size="small"
                  variant="contained"
                  style={{
                    backgroundColor: "#dcfce7",
                    color: "#14532d",
                    textTransform: "none",
                    boxShadow: "none",
                  }}
                >
                  Increase Rate
                </Button>
              </div>

              {/* Card 3 */}
              <div
                className="ai_alert"
                style={{
                  display: "block",
                  backgroundColor: "#fff7ed",
                  border: "1px solid #ffedd5",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      fontWeight: "bold",
                      color: "#9a3412",
                    }}
                  >
                    <StarRateRoundedIcon /> Reward Low Churn Category
                  </div>
                  <MoreHorizIcon fontSize="small" style={{ color: "#ccc" }} />
                </div>
                <p
                  style={{
                    fontSize: "12px",
                    marginBottom: "10px",
                    color: "#7c2d12",
                  }}
                >
                  Home Services has the lowest seller churn (1.2%).
                </p>
                <p
                  style={{
                    fontSize: "11px",
                    color: "#9a3412",
                    marginBottom: "10px",
                  }}
                >
                  &gt; Adjust rate: 8% &gt; 6.5%
                </p>
                <Button
                  size="small"
                  variant="contained"
                  style={{
                    backgroundColor: "#e0e7ff",
                    color: "#4338ca",
                    textTransform: "none",
                    boxShadow: "none",
                  }}
                >
                  Decrease Rate
                </Button>
              </div>
            </div>
          </div>
        </div>
      </CustomTabPanel>
      <EditCategoryCommission
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
      />
      <AddVendorCommission
        open={open1}
        onClose={handleCloseModal1}
        setOpen={setOpen1}
      />
    </>
  );
};
export default Commissions;
